import { useCallback, useRef } from 'react';
const useSingleAndDoubleClick = (props) => {
    const timer = useRef(null);
    const { onClick, onDoubleClick, timeout = 600 } = props;
    const cancelPendingClick = useCallback(() => {
        if (timer.current) {
            clearTimeout(timer.current);
            timer.current = null;
        }
    }, []);
    const handleItemClick = useCallback((data) => {
        // Мы кэшируем только самое последнее событие клика,
        // поэтому отменяем все ожидающие клики.
        cancelPendingClick();
        timer.current = setTimeout(() => {
            timer.current = null;
            onClick(data);
        }, timeout);
    }, [cancelPendingClick, onClick, timeout]);
    const handleItemDoubleClick = useCallback((data) => {
        cancelPendingClick();
        onDoubleClick(data);
    }, [cancelPendingClick, onDoubleClick]);
    return {
        handleItemClick,
        handleItemDoubleClick,
    };
};
export default useSingleAndDoubleClick;
